import { render, staticRenderFns } from "./SettingsNotifications.vue?vue&type=template&id=056cc0de&scoped=true"
import script from "./SettingsNotifications.vue?vue&type=script&lang=js"
export * from "./SettingsNotifications.vue?vue&type=script&lang=js"
import style0 from "./SettingsNotifications.vue?vue&type=style&index=0&id=056cc0de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056cc0de",
  null
  
)

export default component.exports